@if (forms) {
  <section>
    <div class="row form-group sortable-drop-list-group" cdkDropListGroup>
      <div cdkDropList (cdkDropListEntered)="onDropListEntered($event)" (cdkDropListDropped)="onDropListDropped()"></div>
      @for (form of $any(forms.controls); track form) {
        <div
          cdkDropList
          [cdkDropListDisabled]="maxFiles === 1 || readonly"
          (cdkDropListEntered)="onDropListEntered($event)"
          (cdkDropListDropped)="onDropListDropped()"
          >
          <div class="draggable-container">
            <div class="doc-container">
              @if (!readonly) {
                <div class="delete-file" (click)="delete(form)">
                  <img src="assets/icons/component_icons/close-white.png" alt="close" />
                </div>
              }
              <div
                class="img-wrap"
                [cdkDragDisabled]="maxFiles === 1 || readonly"
                [cdkDragStartDelay]="enableDragDelay ? 50 : 0"
                cdkDrag
                cdkDragRootElement=".draggable-container"
              >
                <div class="icon" [ngClass]="getClass(form.controls['mimeType'].value)"></div>
                @if (showImage(form.controls['mimeType'].value)) {
                  <img
                    [src]="form.controls['src'].value"
                    [alt]="form.controls['title'].value"
                    />
                }
              </div>
              <app-text-box (mousedown)="cancel($event)" [control]="form.controls['title']"></app-text-box>
            </div>
          </div>
        </div>
      }
      @if (fileCount < maxFiles && !readonly) {
        <div class="upload-container">
          @if (externalClickEvent) {
            <app-single-file-upload
              [autoReset]="true"
              [allowedMimeTypes]="allowedMimeTypes"
              (filesSelected)="onFileChange($event)"
              [externalClickEvent]="externalClickEvent"
              [ngStyle]="{ visibility: 'hidden' }"
            ></app-single-file-upload>
          }
          @if (!externalClickEvent) {
            <app-single-file-upload
              [autoReset]="true"
              [allowedMimeTypes]="allowedMimeTypes"
              (filesSelected)="onFileChange($event)"
            ></app-single-file-upload>
          }
        </div>
      }
    </div>
    <div>
      @if (fileCount > maxFiles && !readonly) {
        <p class="error-text">
          {{ 'ERROR.MAX_FILES_LIMIT_BREACHED' | translate: { maxFiles: maxFiles, fileCount: fileCount } }}
        </p>
      }
    </div>
  </section>
}
